"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminConsole = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const form_panel_1 = require("../../../composite/form/fields/form-panel");
const form_text_area_1 = require("../../../composite/form/fields/form-text-area");
const form_1 = require("../../../composite/form/form");
const admin_console_hook_1 = require("./admin-console-hook");
const admin_console_input_fields_1 = require("./admin-console-input-fields");
function AdminConsole() {
    const intl = (0, react_intl_1.useIntl)();
    const { handleSubmit, handleClear, resultForm, loading } = (0, admin_console_hook_1.useAdminConsole)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Box_1.default, { margin: 2 },
            react_1.default.createElement(Grid_1.default, { container: true, justify: "space-around", spacing: 2 },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 6 },
                    react_1.default.createElement("h1", null,
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_ADMIN_CONSOLE_INPUT_TITLE", defaultMessage: "Vstup" })),
                    react_1.default.createElement(form_1.Form, { editing: true, initialValues: {}, onSubmit: handleSubmit },
                        react_1.default.createElement(admin_console_input_fields_1.AdminConsoleInputFields, { loading: loading, handleClear: handleClear }))),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 6 },
                    react_1.default.createElement("h1", null,
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_ADMIN_CONSOLE_OUTPUT_TITLE", defaultMessage: "V\u00FDstup" })),
                    react_1.default.createElement(form_1.Form, { editing: false, initialValues: { result: '', console: '', log: '' }, 
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        onSubmit: () => { }, ref: resultForm },
                        react_1.default.createElement(form_panel_1.FormPanel, { label: intl.formatMessage({
                                id: 'EAS_ADMIN_CONSOLE_LABEL_RESULT',
                                defaultMessage: 'Výsledek',
                            }) },
                            react_1.default.createElement(form_text_area_1.FormTextArea, { name: "result", labelOptions: { hide: true } })),
                        react_1.default.createElement(form_panel_1.FormPanel, { label: intl.formatMessage({
                                id: 'EAS_ADMIN_CONSOLE_LABEL_CONSOLE',
                                defaultMessage: 'Konzole',
                            }) },
                            react_1.default.createElement(form_text_area_1.FormTextArea, { name: "console", minRows: 7, labelOptions: { hide: true } })),
                        react_1.default.createElement(form_panel_1.FormPanel, { label: intl.formatMessage({
                                id: 'EAS_ADMIN_CONSOLE_LABEL_LOG',
                                defaultMessage: 'Log',
                            }) },
                            react_1.default.createElement(form_text_area_1.FormTextArea, { name: "log", minRows: 10, labelOptions: { hide: true } }))))))));
}
exports.AdminConsole = AdminConsole;
//# sourceMappingURL=admin-console.js.map